import { Button } from './button'
import { Trash2 } from 'lucide-react'

interface ConfirmDialogProps {
    onConfirm: () => void
    onCancel: () => void
    title?: string
    message?: string
}

export const ConfirmDialog = ({
    onConfirm,
    onCancel,
    title = "Revenir à l'écran d'accueil ?",
    message = "Le formulaire sera réinitialisé."
}: ConfirmDialogProps) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-md mx-4">
            <h3 className="text-lg font-medium text-gray-900 mb-4">
                {title}
            </h3>
            <p className="text-gray-600 mb-6">
                {message}
            </p>
            <div className="flex justify-end space-x-4">
                <Button variant="outline" onClick={onCancel}>
                    Non
                </Button>
                <Button onClick={onConfirm} variant="destructive">
                    Oui
                </Button>
            </div>
        </div>
    </div>
)

interface DeactivateDialogProps {
    onDeactivate: () => void
    onCancel: () => void
    title: string
    message: string
    itemType: 'travailleur' | 'bénéficiaire'
}

export const DeactivateDialog = ({
    onDeactivate,
    onCancel,
    title,
    message,
    itemType
}: DeactivateDialogProps) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-lg mx-4">
            <h3 className="text-lg font-medium text-gray-900 mb-4">
                {title}
            </h3>
            <p className="text-gray-600 mb-6 text-sm leading-relaxed">
                {message}
            </p>
            <div className="flex justify-end space-x-3">
                <Button variant="outline" onClick={onCancel}>
                    Annuler
                </Button>
                <Button onClick={onDeactivate} className="bg-orange-600 hover:bg-orange-700">
                    Désactiver le {itemType}
                </Button>
            </div>
        </div>
    </div>
)

interface DeleteConfirmDialogProps {
    onConfirm: () => void
    onCancel: () => void
}

export const DeleteConfirmDialog = ({ onConfirm, onCancel }: DeleteConfirmDialogProps) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-sm mx-4 shadow-xl">
            <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center shrink-0">
                    <Trash2 size={18} className="text-red-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900">Supprimer ?</h3>
            </div>
            <p className="text-sm text-gray-600 mb-6">
                <strong>Attention</strong> — cette action est irréversible.
            </p>
            <div className="flex justify-end gap-3">
                <Button variant="outline" onClick={onCancel}>Non</Button>
                <Button variant="destructive" onClick={onConfirm}>Supprimer</Button>
            </div>
        </div>
    </div>
)